var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "footer-box" },
    [
      _vm.PROCESS_ENV.NODE_PLA === "kby"
        ? [
            _vm._v(
              "\n    Copyright 2024 深圳市创界通科技有限公司. All Rights Reserved.\n    "
            ),
            _c(
              "a",
              {
                attrs: { href: "http://beian.miit.gov.cn/", target: "_blank" }
              },
              [_vm._v("粤ICP备2024268789号-1")]
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.PROCESS_ENV.NODE_PLA === "wg"
        ? [
            _c(
              "a",
              {
                attrs: {
                  href: _vm.htmlUrl + "agreementwg.html",
                  target: "_blank"
                }
              },
              [_vm._v("《盛骁科技用户协议》")]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: {
                  href: _vm.htmlUrl + "privacyagreementwg.html",
                  target: "_blank"
                }
              },
              [_vm._v("《盛骁科技隐私政策》")]
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-41b5aa7e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41b5aa7e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/otherFooter.vue
// module id = null
// module chunks = 